import React, { useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { 
    SelectChangeEvent, 
    Box, 
    Typography,
    CircularProgress,
    IconButton
} from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import TransactionDialog from './add-transaction-modal.tsx';
import AddEarningsDialog, { AddEarningsData } from './add-earnings-type-modal.tsx';
import AddEarningModal from './add-earnings-modal.tsx';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import StatusFilterTabs from '../../Components/Tab/tab.tsx'; // Ensure this path is correct
import '../../Components/Button/button-style.scss';
import Newpagination from '../../Components/Pagination/pagination.tsx';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import { getWarehouseCompanyMapping } from '../Trips/action.ts';
import { getDriversEarnings} from './action.ts';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface DriverEarningsEntry {
    id: number | string;
    slNo: number;
    date: string;
    driverName: string;
    warehouse: string;
    warehouseId?: string;
    ordersDelivered: number;
    distanceTravelled: number;
    amountEarned?: number;
    additions?: number;
    deductions?: number;
    netAmount?: number;
    driver_phone?: string;
    vehicleNumber?: string;
}

const EarningsPage = () => {
    const [earnings, setEarnings] = useState<DriverEarningsEntry[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [totalRecords, setTotalRecords] = useState<number>();  
    const [warehouseOptions, setWarehouseOptions] = useState<{id: string, label: string}[]>([]);
    const [transactionDialogOpen, setTransactionDialogOpen] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState<{name: string, id: string | any} | null>(null);
    const [addEarningsDialogOpen, setAddEarningsDialogOpen] = useState(false);
    const [warehouseIdForModal, setWarehouseIdForModal] = useState<string | null>(null);
    const [activeTab, setActiveTab] = useState<number>(0);
    const [addEarningModalOpen, setAddEarningModalOpen] = useState(false);
    const [monthForApi, setMonthForApi] = useState<string>(''); 
    const [monthMenuAnchor, setMonthMenuAnchor] = useState<null | HTMLElement>(null);  
    const [refreshTransactionDialog, setRefreshTransactionDialog] = useState(false);  
    const [transactionMode, setTransactionMode] = useState<'earning' | 'deduction'>('earning');  
    const [filters, setFilters] = useState({
        driver_leads: null as string | null,
        blacklist: null as string | null,
        left: null as string | null,
        others: null as string | null,
        driver_name: null as string | null,
        driver_phone: null as string | null,
        earnings: null as string | null,
    });

    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const companiesId = userDetailsFromStorage?.companies_id || '';
    const userRole = userDetailsFromStorage?.role || '';
    const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string, name: string } | null>(null);
    const now = new Date();
    const currentMonthLabel = now.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
    });
    const previousMonthDate = new Date(now.getFullYear(), now.getMonth() - 1);
    const previousMonthLabel = previousMonthDate.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
    });
    const [secondTabMonth, setSecondTabMonth] = useState<{
        label: string;
        value: string;
    }>({
        label: previousMonthLabel,
        value: `${previousMonthDate.getFullYear()}-${String(previousMonthDate.getMonth() + 1).padStart(2, '0')}`,
    });

    useEffect(() => {
        const now = new Date();
        if (activeTab === 0) {
            const month = String(now.getMonth() + 1).padStart(2, '0');
            setMonthForApi(`${now.getFullYear()}-${month}`);
        }
        if (activeTab === 1) {
            setMonthForApi(secondTabMonth.value);
        }
    }, [activeTab, secondTabMonth]);

    const getDropdownMonths = (minYear = 2024) => {
        const months = [];
        const now = new Date();
        let date = new Date(now.getFullYear(), now.getMonth() - 1);
        while (
            date.getFullYear() > minYear ||
            (date.getFullYear() === minYear && date.getMonth() >= 11)
        ) {
            months.push({
                label: date.toLocaleDateString('en-US', {
                    month: 'long',
                    year: 'numeric',
                }),
                value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`,
            });

            date.setMonth(date.getMonth() - 1);
        }
        return months;
    };
    const dropdownMonths = getDropdownMonths();
    const fetchDrivers = () => {
        setLoading(true);
        if(monthForApi){
            getDriversEarnings(
            pageSize,
            page,
            monthForApi,
            (response: any) => {   
                if (response && response.data && Array.isArray(response.data)) {
                    const transformedData = response.data.map((driver: any, index: number) => {
                    const earnings = parseFloat(driver.earnings) || 0;
                    const deductions = parseFloat(driver.deductions) || 0;
                    const netAmount = parseFloat(driver.earnings)-parseFloat(driver.deductions) || 0;
                    return {
                        id: driver.driver_id || `driver-${index}`,
                        slNo: (page * pageSize) + index + 1,
                        date: driver.date || new Date().toISOString().split('T')[0],
                        driverName: driver.driver_name || 'Unknown Driver',
                        warehouse: driver.warehouse_name || 'N/A',
                        warehouseId: driver.warehouse_id?.toString() || '',
                        ordersDelivered: driver.total_orders || 0,
                        distanceTravelled: driver.total_distance || 0,
                        amountEarned: earnings,
                        additions: 0,
                        deductions: deductions,
                        netAmount: netAmount,
                        driver_phone: driver.driver_phone || '',
                        vehicleNumber: driver.vehicle_number || 'No Vehicle',
                    };
                });
                setEarnings(transformedData);
                setTotalRecords(response.total_count || response.total || transformedData.length);
            } else {
                setEarnings([]);
                setTotalRecords(0);
            }
            setLoading(false);
        },
        (errorMessage: string) => {
            toast.error(`Failed to fetch drivers: ${errorMessage}`);
            setLoading(false);
            if (earnings.length === 0) {
                setEarnings([]);
                setTotalRecords(0);
            }
        });}
    };

    const fetchWarehouses = () => {
       getWarehouseCompanyMapping(
            companiesId,
            (response: any) => {
                if (response && response.user_warehouses) {
                    const options = response.user_warehouses.map((warehouses: any) => ({
                        id: warehouses.warehouse.id,
                        label: warehouses.warehouse.name,
                    }));
                    setWarehouseOptions(options);
                } else {
                    toast.error('Failed to fetch warehouses: Invalid response structure');
                }
            },
            (errMessage: any) => {
                toast.error(errMessage.message || 'Failed to fetch warehouses');
            }
        );
    };

    useEffect(() => {
        sessionStorage.removeItem('trips_active_tab');
        fetchWarehouses();
    }, []);
    useEffect(() => {
        fetchDrivers();
    }, [monthForApi]);
    useEffect(() => {
        setPage(0);
    }, [filters.driver_name, filters.driver_phone, selectedWarehouse, activeTab]);

    // Updated Handler for Custom Tab Component
    const handleCustomTabChange = (selectedLabel: string) => {
        if (selectedLabel === currentMonthLabel) {
            setActiveTab(0);
            
            // Logic to reset second tab if needed, copied from original
            const now = new Date();
            const previousMonthDate = new Date(now.getFullYear(), now.getMonth() - 1);
            const previousMonthLabel = previousMonthDate.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric',
            });
            setSecondTabMonth({
                label: previousMonthLabel,
                value: `${previousMonthDate.getFullYear()}-${String(previousMonthDate.getMonth() + 1).padStart(2, '0')}`,
            });

        } else {
            setActiveTab(1);
        }
    };

    const handleAddTransactionClick = (mode: 'earning' | 'deduction') => {
        setTransactionMode(mode);
        setAddEarningModalOpen(true);
    };
    const handleAddEarningsClick = () => {
        setAddEarningsDialogOpen(true);
    };
    const handleAddEarningsSubmit = (earningsData: AddEarningsData) => {        ;
        setAddEarningsDialogOpen(false);   
        setTransactionDialogOpen(false);   
        fetchDrivers();
    };

    const handleCloseTransactionDialog = () => {
        setTransactionDialogOpen(false);
         setAddEarningModalOpen(false);
        setSelectedDriver(null);
        setWarehouseIdForModal(null);
    };

    const handleCloseAddEarningsDialog = () => {
        setAddEarningsDialogOpen(false);
    };

    const handleWarehouseChange = (event: SelectChangeEvent<string>) => {
        const warehouseId = event.target.value;
        const warehouse = warehouseOptions.find(c => c.id === warehouseId);
        const transformedWarehouse = warehouse ? { id: warehouse.id, name: warehouse.label } : null;
        setSelectedWarehouse(transformedWarehouse);
        setPage(0);
    };

    const handlePageClick = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage - 1);
    };
    
    const updateField = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        if (!isNaN(Number(value))) {
            setPageSize(Number(value));
            setPage(0);
        }
    };

    const columns: GridColDef[] = [
        { 
            field: 'slNo', 
            headerName: 'Sl No', 
            width: 100, 
            headerAlign: 'center', 
            align: 'center' 
        },
        { 
            field: 'driverName', 
            headerName: 'Driver Name', 
            width: 200, 
            headerAlign: 'center',
             align: 'center'  
        },
        { 
            field: 'warehouse', 
            headerName: 'Warehouse', 
            width: 200, 
            headerAlign: 'center' ,
             align: 'center' 
        },
        { 
            field: 'amountEarned', 
            headerName: 'Gross Amount', 
            width: 140, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const amount = params.value || 0;
                return (
                    <span style={{ fontWeight: '500', color: '#1976d2' }}>
                        ₹{amount.toFixed(2)}
                    </span>
                );
            }
        },
        { 
            field: 'deductions', 
            headerName: 'Deductions', 
            width: 150, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const deductions = params.value || 0;
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                        <span style={{ 
                            color: deductions > 0 ? '#d32f2f' : '#666', 
                            fontWeight: '500' 
                        }}>
                            {deductions > 0 ? `-₹${deductions.toFixed(2)}` : '₹0.00'}
                        </span>
                    </div>
                );
            }
        },

        { 
            field: 'netAmount', 
            headerName: 'Net Amount', 
            width: 150, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const entry = params.row as DriverEarningsEntry;
                const netAmount = entry.netAmount || 0;
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                        <span style={{ 
                            color: netAmount >= 0 ? '#2e7d32' : '#d32f2f', 
                            fontWeight: 'bold',
                            fontSize: '14px'
                        }}>
                            {netAmount >= 0 ? `₹${netAmount.toFixed(2)}` : `-₹${Math.abs(netAmount).toFixed(2)}`}
                        </span>
                    </div>
                );
            }
        },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 1, 
            width: 80,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const entry = params.row as DriverEarningsEntry;
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', gap: '8px' }}>                    
                        <IconButton 
                            sx={{ 
                                color: '#1976d2',
                                backgroundColor: '#e3f2fd',
                                '&:hover': {
                                    backgroundColor: '#bbdefb',
                                }
                            }}
                            onClick={() => {
                                setSelectedDriver({
                                    id: entry.id,
                                    name: entry.driverName
                                });
                                setWarehouseIdForModal(entry.warehouseId || null);
                                setTransactionDialogOpen(true);
                            }} 
                            title="Edit Earnings" 
                        >
                            <EditIcon />
                        </IconButton>
                    </div>
                );
            },
        }
    ];

    const showEntries = [
        { id: '10', label: '10' },
        { id: '20', label: '20' },
        { id: '50', label: '50' },
        { id: '100', label: '100' },
    ];

    return (
        <>
            <Header />
            <div style={{ marginTop: "70px", paddingBottom: "80px" }}>                
                <Heading
                    title="Earnings" 
                    closeIcon="false"
                    leftContent={
                        <>
                            <Box display="flex" alignItems="center" marginLeft={'10px'}>
                                <Typography style={{ marginRight: '5px' }}>Show Entries:</Typography>
                                <Dropdown
                                    options={showEntries}
                                    selectedValue={pageSize.toString()}
                                    handleChange={(event) => updateField(event)}
                                    width='75px'
                                    height='25px'
                                />
                            </Box>
                        </>
                    }
                    rightContent={
                        <>
                            <Box display="flex" alignItems="center" gap="10px" marginRight={'10px'}>
                                <Dropdown
                                    options={warehouseOptions}
                                    selectedValue={selectedWarehouse?.id || ''}     
                                    handleChange={(event) => handleWarehouseChange(event)}
                                    placeholder="Choose Warehouse"
                                    label="Choose Warehouse"
                                    searchable={true}
                                    width='190px'
                                    height='50px'
                                />
        
                               {userRole !== 'vendor_supervisor' && (
                                    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', opacity:1 }}>
                                        <IconButton
                                            className="settings-btn"
                                            onClick={handleAddEarningsClick}
                                            title="Settings"
                                        >
                                            <SettingsIcon />
                                        </IconButton>
                                    </Box>
                                )}

                            </Box>
                        </>
                    }
                />
                
                {/* REPLACED TABS SECTION */}
                <Box sx={{ 
                    marginLeft: { xs: '10px', sm: '180px' },
                    marginRight: '40px',
                    marginTop: '10px',
                    marginBottom: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}>
                    <StatusFilterTabs 
                        tabs={[currentMonthLabel, secondTabMonth.label]}
                        activeTab={activeTab === 0 ? currentMonthLabel : secondTabMonth.label}
                        onTabChange={handleCustomTabChange} 
                    />
                    
                    {/* Dropdown Trigger for Previous Month Selection */}
                    <IconButton 
                        onClick={(e) => setMonthMenuAnchor(e.currentTarget)} 
                        size="small"
                        sx={{ bgcolor: '#f5f5f5' }}
                        title="Select Month"
                    >
                        <ArrowDropDownIcon />
                    </IconButton>

                    <Menu
                        anchorEl={monthMenuAnchor}
                        open={Boolean(monthMenuAnchor)}
                        onClose={() => setMonthMenuAnchor(null)}
                    >
                        {dropdownMonths.map((month) => (
                            <MenuItem
                                key={month.value}
                                onClick={() => {
                                    setSecondTabMonth(month);
                                    setActiveTab(1);
                                    setMonthMenuAnchor(null);
                                }}
                            >
                                {month.label}
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
                {/* END REPLACED TABS SECTION */}

                <Box className="table-container custom-data-grid" sx={{ 
                    marginLeft: {
                        xs: '10px', 
                        sm: '180px', 
                    },
                    marginTop: '10px', 
                    marginRight: '40px', 
                    position: 'relative', 
                    height: '500px', 
                    overflowY: 'auto' 
                }}>
                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <DataGrid
                            rows={earnings} 
                            columns={columns}
                            autoHeight
                            disableExtendRowFullWidth={true}
                            disableRowSelectionOnClick
                            hideFooterPagination
                            loading={loading}
                            getRowId={(row) => row.id}
                        />
                    )}
                </Box>
                <div style={{
                    marginTop: '20px',
                    marginLeft: '50%'
                }}>
                    <Newpagination
                        rows={totalRecords}
                        pageSize={pageSize}
                        page={page}
                        handlePageChange={handlePageClick}
                    />
                </div>
            </div>
            
            <NavBar selected="Earnings" />
            <TransactionDialog
                open={transactionDialogOpen}
                onClose={handleCloseTransactionDialog }
                driverName={selectedDriver?.name}
                driverId={selectedDriver?.id}
                warehouseId={warehouseIdForModal}
                onAddTransactionClick={handleAddTransactionClick}
                selectedMonth={monthForApi}
            refreshTrigger={refreshTransactionDialog}
            />
            <AddEarningModal
                open={addEarningModalOpen}
                onClose={() => setAddEarningModalOpen(false)}
                driverName={selectedDriver?.name}
                driverId={selectedDriver?.id}
                warehouseId={warehouseIdForModal}
                mode={transactionMode}
                month={monthForApi}
                onSuccess={() => {
                    setRefreshTransactionDialog(prev => !prev);
                    fetchDrivers();
                }}
            />
            <AddEarningsDialog
                open={addEarningsDialogOpen}
                onClose={handleCloseAddEarningsDialog}
                onSubmit={handleAddEarningsSubmit}
                title="Add Earnings"
            />
            
        </>
    );
};

export default EarningsPage;